import { pick, pickBy, map } from 'lodash-es'
import qs from 'qs'
import useProjectStore from '../project/use-project-store'

// 项目
const RAP = process.env.REACT_APP_PROJECT
// 环境(dev,test,prod)
const DEP_ENV = process.env.REACT_APP_DEP
const isEnvExist = ['dev', 'test', 'prod'].includes(DEP_ENV)

// 判断是否是当前项目，是否需要切换项目
const isReverseNav = (nav) => {
  // console.log('RAP', RAP, nav)
  if (RAP && nav.project) {
    // 切换项目
    // FIXME: 有导航编辑器之后修改project
    if (nav.project === 'web') {
      return false
    }
    return RAP !== nav.project
  }
  return false
}

function useRouteTo(adaptor, props = {}) {
  const { getToken, config } = useProjectStore((s) =>
    pick(s, ['getToken', 'config'])
  )

  // 类似/apps/$appId/res/95?token=$token'形式的路径参数值替换
  const transUrl = (url) => {
    const token = getToken()

    const mergedProps = {
      token,
      key: RAP,
      cpkey: `/cp/${RAP}`,
      ...props,
    }
    if (!url) return null

    let finalUrl = url

    const vars = finalUrl.match(/\$[a-zA-Z]+/g) || []

    vars.forEach((v) => {
      const key = v.replace('$', '')
      finalUrl = finalUrl.replace(v, mergedProps[key])
    })

    // if (appId) {
    //   finalUrl = url.replace('$appId', appId)
    // }

    // finalUrl = finalUrl.replace('$token', token)
    // finalUrl = finalUrl.replace('$key', RAP)
    // finalUrl = finalUrl.replace('$cpkey', `/cp/${RAP}`)
    return finalUrl
  }

  // 将接口返回的导航数据中的url转换为可跳转的url
  const transUrlIte = (nav, appId) => {
    let arr = null
    if (nav.children) {
      arr = nav.children.map((childNav) => transUrlIte(childNav, appId))
    }
    // 需要和浏览器url匹配的内容（token、appid等已经转换）
    let matchUrl
    /**
     * matchType 需要和url匹配的类型 query|url
     * ignoreQuery 需要忽略的query
     */
    const { matchType, ignoreQuery = [] } = nav
    // 如果需要从url中的query中进行匹配
    if (matchType === 'query') {
      /**
       * url中的query部分
       * @return string
       */
      const query = qs.parse(nav.url.split('?')[1])
      /**
       * 将ignoreQuery过滤后的内容
       * @return object
       */
      const matchQuery = pickBy(query, (value, key) => {
        return !(ignoreQuery && ignoreQuery.includes(key))
      })
      /**
       * 需要match的url
       * @return string
       */
      const matchQueryUrl = map(matchQuery, (value, key) => {
        return `${key}=${value}`
      }).join('&')
      matchUrl = transUrl(matchQueryUrl)
    } else matchUrl = transUrl(nav.url)
    return {
      ...nav,
      matchUrl,
      children: arr,
    }
  }

  const reverseNav = (nav) => {
    const { projects } = config || {}
    console.log(config)
    // 先判断环境
    if (!isEnvExist && !projects) {
      return nav.url
    }

    // const env = projects[DEP_ENV]
    // const project = env[nav.project]
    const project = projects[nav.project]
    if (!project) {
      return nav.url
    }

    if (DEP_ENV === 'dev' && project.port) {
      return `//${document.location.hostname}:${project.port}${nav.url}`
    }
    if ((DEP_ENV === 'test' || DEP_ENV === 'prod') && project.port) {
      return `//${project.domain}${nav.url}`
    }
    return nav.url
  }

  // 路径跳转方式
  /* eslint-disable no-unused-expressions */
  const UrlJumpMode = (nav = {}) => {
    const url = transUrl(nav.url)
    const isReverse = isReverseNav(nav)
    console.log(
      `${nav.navType} to:`,
      url,
      process.env,
      `isReverse: ${isReverse}`
    )
    // console.log(isReverse)
    if (nav.navType === 'push') {
      if (isReverse) {
        return { navType: 'href', url: transUrl(reverseNav(nav)) }
      }
      return { navType: 'push', url }
    }
    if (nav.navType === 'replace') {
      if (isReverse) {
        return { navType: 'href', url: transUrl(reverseNav(nav)) }
      }
      return { navType: 'replace', url }
    }
    if (nav.navType === 'refresh') {
      if (isReverse) {
        return { navType: 'push', url }
      }
      return { navType: 'href', url }
    }
    if (nav.navType === 'open') {
      if (nav.project && isReverse) {
        return { navType: 'open', url: transUrl(reverseNav(nav)) }
      }
      return { navType: 'open', url }
    }
    return {}
  }

  const routeTo = (url) => {
    if (typeof url === 'object') {
      const obj = UrlJumpMode(url)
      const { navType } = obj
      if (obj.url) {
        if (navType === 'push') {
          adaptor.push(obj)
        } else if (navType === 'replace') {
          adaptor.replace(obj)
        } else if (navType === 'href') {
          adaptor.jump(obj)
        } else if (navType === 'open') {
          adaptor.open(obj)
        } else {
          adaptor.open(obj)
        }
      }
    } else {
      adaptor.open({ url })
    }
  }

  return {
    transUrl,
    routeTo,
    transUrlIte,
  }
}

export default useRouteTo
